import { Injectable } from "@angular/core";

import { CommonState } from "../../../state";
import { BettingLimit } from "../betting-limit.model";

@Injectable({
	providedIn: "root",
})
export class NetlossLimitSelector {
	getActiveNetlossLimit() {
		return (state: CommonState): BettingLimit | undefined => state.netlossLimit.activeNetlossLimit;
	}

	getQueuedNetlossLimit() {
		return (state: CommonState): BettingLimit | undefined => state.netlossLimit.queuedNetlossLimit;
	}

	getNetlossLimits() {
		return (state: CommonState): BettingLimit[] | undefined => state.netlossLimit.bettingLimits;
	}
}
